import React, { useEffect, useState } from 'react';
import { useAppSelector } from 'flow/hooks/useRedux';
import NotifierBanner from 'flow/components/custom-components/NotifierBanner';

import useAppContext from 'flow/hooks/useAppContext';

const MicPermissionNotifier = () => {
    const micPermission = useAppSelector((state) =>
        state.app.get('micPermission'),
    );

    const { i18next } = useAppContext();
    const [showNotifier, setShowNotifier] = useState(false);

    useEffect(() => {
        if (typeof micPermission === 'undefined') {
            return;
        }

        setShowNotifier(!micPermission);
    }, [micPermission]);

    if (!showNotifier) {
        return null;
    }

    return (
        <NotifierBanner
            message={i18next.t('permission.microphone.not_granted')}
            buttonText={i18next.t('dismiss')}
            handleClick={() => setShowNotifier(false)}
            theme={'warning'}
        />
    );
};

export default MicPermissionNotifier;
